<template>
	<div class="layout-wrapper story">
		<div
			class="row"
			style="background-color: white; padding: 16px; flex-wrap: wrap"
		>
			<UIShInputText
				name="name"
				v-model="inputValue"
				label="Title"
				required
				hint="мм"
			/>
			<UIShInputNumber
				name="name"
				v-model="inputNumber"
				label="Number"
				required
				hint="мм"
			/>
			<UIShInputText
				name="name"
				v-model="inputValue"
				label="Title"
				error="Error message"
			/>
			<UIShInputText
				name="name"
				v-model="inputValue"
				label="Title"
				disabled
				:xl="768"
			/>
		</div>

		<div v-for="kind in btnKindList" :key="kind" class="row">
			<UIShButton
				v-for="size in BUTTON_SIZES"
				:key="size"
				label="Button CTA"
				:kind="kind"
				:[size]="true"
				icon-left="user-circle"
				icon-right="user-circle"
			/>
		</div>

		<div class="row">
			<UIShButton
				v-for="size in BUTTON_SIZES"
				:key="size"
				:[size]="true"
				label="Button CTA"
				icon-left="user-circle"
				icon-right="user-circle"
				disabled
			/>
		</div>

		<br />

		<div v-for="kind in linkKindList" :key="kind" class="row">
			<UIShLink
				v-for="size in LINK_SIZES"
				:key="size"
				to="/"
				label="Button CTA"
				:[size]="true"
				:kind="kind"
				icon-left="user-circle"
				icon-right="user-circle"
			/>
		</div>

		<div class="row">
			<UIShLink
				v-for="size in LINK_SIZES"
				:key="size"
				to="/"
				:[size]="true"
				label="Button CTA"
				icon-left="user-circle"
				icon-right="user-circle"
				disabled
			/>
		</div>

		<div class="row">
			<UIShButtonLabel label="Удалить" icon-right="trash" sm />
			<UIShButtonLabel label="Удалить" icon-right="trash" md />
			<UIShButtonLabel label="Удалить" icon-right="trash" lg />
			<UIShButtonLabel icon-right="trash" lg />
		</div>

		<div class="row">
			<UIShLinkSocial link="/" icon="tg-social" kind="gray" md />
			<UIShLinkSocial link="/" icon="tg-social" kind="gray" lg />
			<UIShLinkSocial link="/" icon="tg-social" kind="gray" xl />
		</div>

		<div class="row">
			<UIShLinkSocial link="/" icon="tg-social" kind="white" md />
			<UIShLinkSocial link="/" icon="tg-social" kind="white" lg />
			<UIShLinkSocial link="/" icon="tg-social" kind="white" xl />
		</div>
	</div>
</template>

<script setup lang="ts">
import type { ShLinkT } from '@/components/UI/ShLink.vue';
import type { ShButtonT } from '@/components/UI/ShButton.vue';
import { UIShInputText } from '#components';

const BUTTON_SIZES = ['sm', 'md', 'lg', 'xl'];
const LINK_SIZES = ['xs', 'sm', 'md', 'lg'];
const btnKindList: Array<ShButtonT['kind']> = [
	'primary',
	'secondary-gray',
	'secondary-color',
	'tertiary-gray'
];
const linkKindList: Array<ShLinkT['kind']> = ['gray', 'white', 'color'];

const inputValue = ref('');
const inputNumber = ref();
</script>

<style scoped lang="scss">
.story {
	padding: var(--layout-pad-x);
	background-color: #454545;
	position: relative;
}

.group {
	display: flex;
	flex-direction: column;
	gap: 0.667rem;
}

.row {
	display: flex;
	flex-wrap: nowrap;
	gap: 1.111rem;
	align-items: flex-start;
	margin-top: 0.56rem;
}
</style>
